import React from 'react';
import { Redirect } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from '../_layout/DashboardLayout/dashboard.layout';
import LoadingPage from '../_boilerplate/LoadingPage/loading-page.container';
import { PageTitle } from '../../_core/_ui/typography.component';
import { PageHeaderRow } from '../../_core/_ui/structure.components';
import { AccordionSection } from '../../_core/_ui/accordion-section.component';
import { CreateAssociationFormContainer } from './create-association-form.container';
import { FormatTemplateList } from '../../FormatTemplate/FormatTemplateList/format-template-list.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { hasAdminAccess } from '../../../lib/services/user.service';
import { HOME_ROUTE } from '../../../../_configuration';
import { messages } from './admin.messages';

export const AdminPage = () => {
  const { isAdmin, loading } = hasAdminAccess();

  if (loading) return <LoadingPage />;
  if (!isAdmin) return <Redirect to={HOME_ROUTE} />;

  return (
    <DashboardLayout hideSidebar hideAssessmentSelector>
      <PageHeaderRow><PageTitle><IntlMsg {...messages.pageTitle} /></PageTitle></PageHeaderRow>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AccordionSection title={<IntlMsg {...messages.createAssociation} />} defaultExpanded>
            <CreateAssociationFormContainer />
          </AccordionSection>
          <AccordionSection title={<IntlMsg {...messages.globalFormatTemplates} />}>
            <FormatTemplateList scope="SYSTEM" />
          </AccordionSection>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
